import React, { useState } from "react";
import Nav from "../../components/Nav";
import Footer from "../../components/Footer";
import {
  QuestionCOntainer,
  Title,
  OptionsContainer,
  ProgressContainer,
  ButtonContainer,
  NextBtn,
  PrevBtn,
  ProgressText,
  ImgBox,
  ImgIcon,
} from "../../components/QuestionaireStyledComponents/Questionnaire";
import styles from "./questionaire.module.css";
import {
  buildStyles,
  CircularProgressbarWithChildren,
} from "react-circular-progressbar";
import { questions } from "../../data/data";
// import Modal from "@mui/material/Modal";
// import CircularProgress from "@mui/material/CircularProgress";
import { useHistory } from "react-router-dom";
// import CheckBoxIcon from "@mui/icons-material/CheckBox";
import axios from "axios";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
import { motion } from "framer-motion";
import { pageTransition, transit } from "../../animate";
import question0Img from "../../assets/question0.svg";
import question1Img from "../../assets/question1.svg";
import question2Img from "../../assets/question2.svg";
import question3Img from "../../assets/question3.svg";
import question4Img from "../../assets/question4.svg";
import question5Img from "../../assets/question6.svg";
import question6Img from "../../assets/question7.svg";

const Questionnaire = () => {
  // const [openModal, setOpenModal] = React.useState(false);
  const [number, setNumber] = useState(0);
  const [answers, setAnswers] = useState({
    question0: "",
    question1: "",
    question2: "",
    question3: "",
    question4: "",
    question5: "",
    question6: "",
    question7: "",
  });
  const qImages = [
    question0Img,
    question1Img,
    question2Img,
    question3Img,
    question4Img,
    question5Img,
    question6Img,
    question6Img,
  ];

  const [isLoading, setIsLoading] = useState(false);

  const handlePrev = () => {
    if (number > 0) setNumber(number - 1);
  };

  const history = useHistory();

  // const handleOpenModal = () => setOpenModal(true);

  const handleNext = async () => {
    if (number < questions.length - 1 && answers[`question${number}`]) {
      setNumber(number + 1);
    }
    if (answers[`question${number}`] && number === questions.length - 1) {
      const ans = {
        reason: answers.question0,
        home: answers.question1,
        personality: answers.question2,
        shedding: answers.question3,
        activity: answers.question5,
        size: answers.question6,
        upkeep: answers.question7 !== "less than $100" ? 100 : 0,
      };

      try {
        setIsLoading(true);
        console.log(ans);
        const res = await axios({
          method: "POST",
          url: "https://pet-connect-api.herokuapp.com/match",
          data: ans,
          headers: {
            "Content-Type": "application/json",
          },
        });
        setIsLoading(false);
        history.push({
          pathname: "/result",
          state: { data: res.data, range: answers.question4 },
        });
      } catch (e) {
        setIsLoading(false);
        console.log(e);
        alert("an error occurred, try again");
      }
    }
  };

  // const handleClo seModal = () => setOpenModal(false);

  return (
    <motion.div
      initial="out"
      animate="in"
      exit="out"
      variants={pageTransition}
      transition={transit}
    >
      <Nav />
      <QuestionCOntainer>
        <ProgressContainer>
          <CircularProgressbarWithChildren
            value={((number + 1) / questions.length) * 100}
            styles={buildStyles({
              // Rotation of path and trail, in number of turns (0-1)
              rotation: 0.85,
              // Whether to use rounded or flat corners on the ends - can use 'butt' or 'round'
              strokeLinecap: "round",
              // How long animation takes to go from one percentage to another, in seconds
              pathTransitionDuration: 0.5,
              // Colors
              pathColor: "#5E9C98",
              textColor: "#f88",
              trailColor: "#c4c4c4",
              // backgroundColor: "#5E9C98",
            })}
          >
            <ProgressText>
              {number + 1} of {questions.length}
            </ProgressText>
          </CircularProgressbarWithChildren>
        </ProgressContainer>
        <Title>{questions[number].question}</Title>
        <OptionsContainer>
          {questions[number].options.map((option, idx) => (
            <motion.label
              initial="out"
              animate="in"
              exit="out"
              variants={pageTransition}
              transition={transit}
              htmlFor={option}
              className={styles.option}
              key={`${idx}`}
            >
              <input
                type="radio"
                name="question1"
                id={option}
                className={styles.inputQuestion}
                value={option}
                checked={answers[`question${number}`] === option}
                onChange={() => {
                  setAnswers({ ...answers, [`question${number}`]: option });
                }}
              />
              <div className={styles.inputCheckbox}>
                <div className={styles.inputChecked}>
                  {/* <div className={styles.checkBtn}>&nbsp;</div> */}
                </div>
              </div>
              <p className={styles.inputLabel}> {option} </p>
            </motion.label>
          ))}
        </OptionsContainer>
        {/*  ImgBox ImgIcon */}
        <ImgBox>
          {qImages.map((img, idx) =>
            idx <= number ? (
              <motion.div
                initial="out"
                animate="in"
                exit="out"
                variants={pageTransition}
                transition={transit}
              >
                <ImgIcon
                  initial="out"
                  animate="in"
                  exit="out"
                  variants={pageTransition}
                  transition={transit}
                  src={img}
                  alt="q"
                />
              </motion.div>
            ) : (
              <> </>
            )
          )}
        </ImgBox>
      </QuestionCOntainer>
      <ButtonContainer>
        {number > 0 && <PrevBtn onClick={handlePrev}>Go Back</PrevBtn>}
        <NextBtn
          onClick={handleNext}
          style={{
            cursor: answers[`question${number}`] ? "pointer" : "not-allowed",
          }}
        >
          {isLoading ? (
            <Loader type="Oval" color="#FFFFFF" height={30} width={30} />
          ) : number + 1 === questions.length ? (
            "Finish"
          ) : (
            "Next"
          )}
        </NextBtn>
      </ButtonContainer>
      <Footer />
    </motion.div>
  );
};

export default Questionnaire;
